import script from "./CircleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleButton.vue?vue&type=script&setup=true&lang=js"

import "./CircleButton.vue?vue&type=style&index=0&id=46a8ab47&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a8ab47"]])

export default __exports__